<template>
    <div class="userAvatar" @click="$emit('avatar-clicked')">
        <div class='imgWrap' v-if='user.Phonecode'>
            <img v-if='user.Phonecode && user.Phonecode.pc_avatar' :src="'https://s3.amazonaws.com/callbox-images-external/avatars/' + user.frn_phonecodeid + '.jpg'">
            <img v-else src="https://assets-cdn.carwars.com/cw/avatar-placeholders/placeholder_2.jpg">
        </div>
        <div class='imgWrap' v-else>
            <img src="https://assets-cdn.carwars.com/cw/avatar-placeholders/placeholder_unknown.jpg">
        </div>
        <div v-if='user.Phonecode && !mobileView' class="statusIndicator" :class ='{ available: classStatus.available, workTimeStatus: classStatus.workTime, unavailable: classStatus.notavailable, neutral: classStatus.neutral }'></div>
    </div>
</template>

<script>
// "mobileView" is a boolean prop that can be used to hide the status indicator when in mobile view (ie in popup)
// "avatar-clicked" emitted event can be used when an action needs to happen when an avatar is clicked 
export default {
    name: 'UserAvatar',
    props: ['mobileView', 'user', 'classStatus']
}
</script>